import { render } from "./StudyGroupsView.vue?vue&type=template&id=160a5262&scoped=true"
const script = {}

import "./StudyGroupsView.vue?vue&type=style&index=0&id=160a5262&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160a5262"]])

export default __exports__